module.exports = __webpack_public_path__ + "media/images/gallagher_lifetime_logo_reversed-a020786f94b874ba8924d88ce0d04936.png";